import { render } from "./past-payments.vue?vue&type=template&id=70147181&ts=true"
import script from "./past-payments.vue?vue&type=script&lang=ts"
export * from "./past-payments.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__